import Hero from "@/components/home/Hero";
import PopularDestinations from "@/components/home/PopularDestinations";
import FeaturedDeals from "@/components/home/FeaturedDeals";
import TopAirlines from "@/components/home/TopAirlines";
import FeaturedHotels from "@/components/home/FeaturedHotels";
import TravelCategories from "@/components/home/TravelCategories";
import BlogTeasers from "@/components/home/BlogTeasers";
import NewsletterBanner from "@/components/home/NewsletterBanner";
import Testimonials from "@/components/home/Testimonials";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <PopularDestinations />
      <FeaturedDeals />
      <TopAirlines />
      <FeaturedHotels />
      <TravelCategories />
      <BlogTeasers />
      <NewsletterBanner />
      <Testimonials />
    </div>
  );
}
